import type { FormEvent } from 'react';

interface LoginScreenProps {
  error: string;
  loading: boolean;
  onSubmit: (event: FormEvent<HTMLFormElement>) => void;
}

export function AuthShell({ title, subtitle }: { title: string; subtitle: string }) {
  return (
    <main className="auth-shell">
      <section className="auth-panel">
        <div className="auth-mark">C</div>
        <h1>{title}</h1>
        <p>{subtitle}</p>
      </section>
    </main>
  );
}

export function LoginScreen({ error, loading, onSubmit }: LoginScreenProps) {
  return (
    <main className="auth-shell">
      <section className="auth-panel">
        <div className="auth-mark">C</div>
        <h1>Báo cáo hiệu quả tư vấn</h1>
        <p>Đăng nhập bằng tài khoản GearVN để xem dữ liệu cửa hàng và online.</p>
        <form className="auth-form" onSubmit={onSubmit}>
          <label htmlFor="login-username">Tài khoản</label>
          <input autoComplete="username" id="login-username" name="username" placeholder="Username" required type="text" />
          <label htmlFor="login-password">Mật khẩu</label>
          <input autoComplete="current-password" id="login-password" name="password" placeholder="Password" required type="password" />
          {error && <div className="auth-error">{error}</div>}
          <button className="btn primary" disabled={loading} type="submit">{loading ? 'Đang đăng nhập...' : 'Đăng nhập'}</button>
        </form>
        <div className="auth-hint">Dữ liệu chỉ hiển thị sau khi tài khoản được xác thực.</div>
      </section>
    </main>
  );
}
